<template>
  <div>
    <vx-card
      ref="filterCard"
      title="Filters"
      class="user-list-filters mb-8"
      actionButtons
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">From </label>

          <flat-pickr
            placeholder="Select Date"
            :config="configFromdateTimePicker"
            v-model="fromDate"
            @on-change="onFromChange"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">To </label>
          <flat-pickr
            :config="configTodateTimePicker"
            v-model="toDate"
            placeholder="To Date"
          />
        </div>

        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="collectionAgentsList"
          style="display: -webkit-inline-box"
        >
          <label class="text-sm opacity-75" style="padding-right: 1rem"
            >Collection Agent</label
          >
          <vs-select
            class="collectionAgen"
            placeholder="Collection Agent"
            v-model="collectionAgentId"
            max-selected="5"
            multiple
            autocomplete
            @input="fromCollectionAgentSelected"
          >
            <vs-select-item
              v-for="(item, index) in collectionAgentsList"
              :key="index"
              :value="item.collectionAgentId"
              :text="item.collectionAgentName"
            />
          </vs-select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-button @click="getDDS" class="ml-auto">Show</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6" v-if="collectionsData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  collectionsData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : collectionsData.length
                }}
                of {{ collectionsData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            "
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <!-- <vs-dropdown-item @click="showpdf">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Print</span>
              </span>
            </vs-dropdown-item> -->

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>
                  <download-excel
                    :data="getCSVData"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    :name="csvFileName"
                  >
                    CSV
                  </download-excel>
                </span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="collectionsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
      >
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <div
      class="vx-card p-6"
      v-else-if="collectionsData.length === 0 && this.sentRequest"
    >
      <b>No Collections Found</b>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    flatPickr,
    "ag-grid-vue": AgGridVue
  },
  data() {
    return {
      json_fields: {
        "LR No": "consignmentLrNo",
        From: "consignmentFromBranchName",
        To: "consignmentToBranchName",
        Consignor: "consignmentConsignorData",
        Consignee: "consignmentConsigneeData",
        "Freight No": "consignmentFreightNo",
        "Freight Charge": "consignmentGrandTotalCharge",
        "Collection Agent": "collectionAgentName",
        "Booked Date": {
          field: "consignmentBookedDate",
          callback: value => {
            return value;
          }
        },
        "Delivered Date": {
          field: "consignmentDeliveredOn",
          callback: value => {
            return value;
          }
        },
        "Booking Type": "bookingType",
        "Collection Status": "collectionStatus",
        "Current Payment Status": "currentPaymentStatus",
        "Collection Date": "collectionDate"
      },

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      csvData: {
        data: []
      },
      csvFileName: `collectionReport-${Math.round(+new Date() / 100)}`,
      sentRequest: false,
      collectionsData: [],
      fromDate: null,
      toDate: null,
      collectionAgentId: [],
      minDate: null,
      collectionAgentsList: [
        { collectionAgentName: "All", collectionAgentId: 999 }
      ],
      configFromdateTimePicker: {
        altFormat: "M j, Y",
        dateFormat: "d-m-Y"
      },

      configTodateTimePicker: {
        minDate: null,
        dateFormat: "d-m-Y"
      },
      searchQuery: "",
      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2025/",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "From",
          field: "consignmentFromBranchName",
          filter: true,
          width: 210
        },
        {
          headerName: "To",
          field: "consignmentToBranchName",
          filter: true,
          width: 225
        },
        {
          headerName: "LR  No",
          field: "consignmentLrNo",
          filter: true,
          width: 200
        },
        {
          headerName: "Freight No",
          field: "consignmentFreightNo",
          filter: true,
          width: 150
        },
        {
          headerName: "Collection Agent",
          field: "collectionAgentName",
          filter: true,
          width: 150
        },

        {
          headerName: "Consignor",
          field: "consignmentConsignorData",
          filter: true,
          width: 150
        },
        {
          headerName: "Consignee",
          field: "consignmentConsigneeData",
          filter: true,
          width: 150
        },
        {
          headerName: "Freight",
          field: "consignmentGrandTotalCharge",
          filter: true,
          width: 150
        },
        {
          headerName: "Booked Date",
          field: "consignmentBookedDate",
          filter: true,
          width: 150
        },

        {
          headerName: "Booking Type",
          field: "consignmentBookingPaymentType",
          filter: true,
          width: 150,
          valueFormatter: _params => {
            if (_params.value) {
              let currentPaymentStatus = "";
              if (_params.value == 1) {
                currentPaymentStatus = "Paid";
              } else if (_params.value == 2) {
                currentPaymentStatus = "To Pay";
              } else if (_params.value == 3) {
                currentPaymentStatus = "TBB";
              } else {
                currentPaymentStatus = "--";
              }
              return currentPaymentStatus;
            }
          }
        },
        {
          headerName: "Collection Status",
          field: "collectionStatusId",
          filter: true,
          width: 150,
          valueFormatter: _params => {
            if (_params.value) {
              let collectionStatus = "";
              if (_params.value == 1) {
                collectionStatus = "Sent for Collection";
              } else if (_params.value == 2) {
                collectionStatus =
                  "Not Paid this collection went for another time";
              } else if (_params.value == 3) {
                collectionStatus = "Paid";
              } else if (_params.value == 4) {
                collectionStatus = "Paid";
              } else {
                collectionStatus = "--";
              }
              return collectionStatus;
            }
          }
        },
        {
          headerName: "Current Payment Status",
          field: "consignmentPaymentStatus",
          filter: true,
          width: 150,
          valueFormatter: _params => {
            if (_params.value) {
              let paymentStatus = "";
              if (_params.value == 1) {
                paymentStatus = "Paid";
              } else if (_params.value == 2) {
                paymentStatus = "To Pay";
              } else if (_params.value == 3) {
                paymentStatus = "TBB";
              } else {
                paymentStatus = "--";
              }
              return paymentStatus;
            }
          }
        },
        {
          headerName: "Collection Date",
          field: "collectionCreatedOn",
          filter: true,
          width: 150,
          valueFormatter: _params => {
            if (_params.value) {
              return _params.value;
            }
          }
        }
      ]
    };
  },
  methods: {
    exportcsv() {
      this.gridApi.exportDataAsCsv();
    },
    showpdf() {
      const url =
        this.pdfUrl +
        "ddspdf.php?branch=" +
        this.collectionAgentId.join(",") +
        "&fromDate=" +
        this.fromDate +
        "&toDate=" +
        this.toDate;
      // alert(url);
      window.open(url, "_blank");
      return false;
      // alert("Show PDF");
    },
    onFromChange(selectedDates, dateStr, _instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    getDDS() {
      this.sentRequest = false;
      this.$http
        .post("portage/collectionagentreport", {
          fromDate: this.fromDate,
          toDate: this.toDate,
          collectionAgentId: this.collectionAgentId
        })
        .then(response => {
          const csv = [];
          this.collectionsData = response.data.data;
          this.collectionsData.forEach(element => {
            let bookingPaymentStatus = "--";
            let collectionStatus = "--";
            let currentPaymentStatus = "--";
            if (element.bookingpaymentstatusid == 1) {
              bookingPaymentStatus = "";
            } else {
              bookingPaymentStatus = "";
            }

            if (element.collectionStatusId == 1) {
              collectionStatus = "Sent for Collection";
            } else if (element.collectionStatusId == 2) {
              collectionStatus =
                "Not Paid this collection went for another time";
            } else if (element.collectionStatusId == 3) {
              collectionStatus = "Paid";
            } else if (element.collectionStatusId == 4) {
              collectionStatus = "Paid";
            } else {
              collectionStatus = "--";
            }
            if (element.consignmentPaymentStatus == 1) {
              currentPaymentStatus = "Paid";
            } else if (element.consignmentPaymentStatus == 2) {
              currentPaymentStatus = "To Pay";
            } else if (element.consignmentPaymentStatus == 3) {
              currentPaymentStatus = "TBB";
            } else {
              currentPaymentStatus = "--";
            }
            console.log(
              collectionStatus,
              currentPaymentStatus,
              bookingPaymentStatus
            );
            const record = {
              consignmentLrNo: element.consignmentLrNo,
              collectionAgentName: element.collectionAgentName,
              consignmentFromBranchName: element.consignmentFromBranchName,
              consignmentToBranchName: element.consignmentToBranchName,
              consignmentConsignorData: element.consignmentConsignorData,
              consignmentConsigneeData: element.consignmentConsigneeData,
              consignmentFreightNo: element.consignmentFreightNo,
              consignmentGrandTotalCharge: element.consignmentGrandTotalCharge,
              consignmentBookedDate: element.consignmentBookedDate,
              consignmentDeliveredOn: element.consignmentDeliveredOn,
              bookingType: bookingPaymentStatus,
              collectionStatus: collectionStatus,
              currentPaymentStatus: currentPaymentStatus,
              collectionDate: element.collectionCreatedOn
            };
            csv.push(record);
          });
          const sampleData = JSON.parse(JSON.stringify(csv));
          // console.log(this.csvData, sampleData);
          this.csvData.data = sampleData;
          // this.csvData.subscribe(data => console.log(data));
          console.log(this.csvData.data);
          this.sentRequest = true;
        });
    },

    fromCollectionAgentSelected() {
      // console.log(this.collectionAgentId);
      if (this.collectionAgentId.includes(999)) {
        this.collectionAgentId = [];
        setTimeout(() => {
          this.collectionAgentId.push(999);
        }, 10);
      } else {
        //nothing
      }
    }
  },
  computed: {
    getCSVData() {
      const sampleData = JSON.parse(JSON.stringify(this.csvData.data));

      return [...sampleData];
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        if (this.gridApi) this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  beforeMount() {
    this.$http.get("portage/collectionAgents").then(response => {
      this.collectionAgentsList.push(...response.data.data);
    });
  }
};
</script>
